/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExerciseTimingDto } from './ExerciseTimingDto';
import {
    ExerciseTimingDtoFromJSON,
    ExerciseTimingDtoFromJSONTyped,
    ExerciseTimingDtoToJSON,
    ExerciseTimingDtoToJSONTyped,
} from './ExerciseTimingDto';

/**
 * 
 * @export
 * @interface ExerciseConfig
 */
export interface ExerciseConfig {
    /**
     * 
     * @type {ExerciseTimingDto}
     * @memberof ExerciseConfig
     */
    timing?: ExerciseTimingDto;
    /**
     * 
     * @type {number}
     * @memberof ExerciseConfig
     */
    bodyweightPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof ExerciseConfig
     */
    executionType: ExerciseConfigExecutionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ExerciseConfig
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof ExerciseConfig
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof ExerciseConfig
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExerciseConfig
     */
    trackPerSide?: boolean;
}


/**
 * @export
 */
export const ExerciseConfigExecutionTypeEnum = {
    Reps: 'reps',
    Duration: 'duration',
    Intervals: 'intervals'
} as const;
export type ExerciseConfigExecutionTypeEnum = typeof ExerciseConfigExecutionTypeEnum[keyof typeof ExerciseConfigExecutionTypeEnum];


/**
 * Check if a given object implements the ExerciseConfig interface.
 */
export function instanceOfExerciseConfig(value: object): value is ExerciseConfig {
    if (!('executionType' in value) || value['executionType'] === undefined) return false;
    return true;
}

export function ExerciseConfigFromJSON(json: any): ExerciseConfig {
    return ExerciseConfigFromJSONTyped(json, false);
}

export function ExerciseConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExerciseConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'timing': json['timing'] == null ? undefined : ExerciseTimingDtoFromJSON(json['timing']),
        'bodyweightPercentage': json['bodyweightPercentage'] == null ? undefined : json['bodyweightPercentage'],
        'executionType': json['executionType'],
        'value': json['value'] == null ? undefined : json['value'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'note': json['note'] == null ? undefined : json['note'],
        'trackPerSide': json['trackPerSide'] == null ? undefined : json['trackPerSide'],
    };
}

export function ExerciseConfigToJSON(json: any): ExerciseConfig {
    return ExerciseConfigToJSONTyped(json, false);
}

export function ExerciseConfigToJSONTyped(value?: ExerciseConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timing': ExerciseTimingDtoToJSON(value['timing']),
        'bodyweightPercentage': value['bodyweightPercentage'],
        'executionType': value['executionType'],
        'value': value['value'],
        'weight': value['weight'],
        'note': value['note'],
        'trackPerSide': value['trackPerSide'],
    };
}

